"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const DotsPopover_1 = __importDefault(require("@Components/DotsPopover"));
const permission_actions_1 = require("@App/enum/permission-actions");
const contexts_1 = require("@App/contexts");
const PermissionHeadMenu = (props) => {
    const { rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { onOpenConfirmPopup } = props;
    return (react_1.default.createElement("div", { className: 'head-menu' },
        react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.rightholder.maintenance.userPermissions(rightsholderStore.currentRightsholderId), className: 'back small black-text bold' }, `< Back`),
        react_1.default.createElement("div", { className: 'buttons-block' },
            react_1.default.createElement(DotsPopover_1.default, null,
                react_1.default.createElement("p", { onClick: () => onOpenConfirmPopup(permission_actions_1.PermissionActions.resentInvite) }, "Resend Invite"),
                react_1.default.createElement("p", { onClick: () => onOpenConfirmPopup(permission_actions_1.PermissionActions.removeUser), className: 'delete' }, "Remove User")))));
};
exports.default = (0, mobx_react_1.observer)(PermissionHeadMenu);
